function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as o } from "./index.es33.js";
import { clsx as c } from "./index.es105.js";
import { Icon as m } from "./index.es7.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as s } from "./index.es36.js";
import { useControlColor as l } from "./index.es508.js";
import "react";
import "./index.es15.js";
import "./index.es172.js";
import i from "./index.es584.js";

var a = {
  active: s.blue6,
  hidden: s.gray6
},
    T = function T(n) {
  return function (r) {
    var t = r.isVisibleDisabled,
        e = r.isAlwaysVisible,
        p = l({
      isAlwaysVisible: e,
      isVisibleDisabled: t,
      colorsConfig: a
    });
    return o.jsx(n, _objectSpread(_objectSpread({}, r), {}, {
      children: o.jsx("div", {
        className: c(i.iconContainer, _defineProperty({}, i.iconContainerDisabled, t)),
        children: o.jsx(m, {
          className: i.iconContainer,
          icon: m.icons.outline.info,
          color: p,
          size: 16
        })
      })
    }));
  };
};

export { T as IconWithTooltipFactory };